module.exports = __webpack_public_path__ + "static/img/bg-overview@t.74ae77f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/premium-food-market/bg-overview@t.jpg
// module id = F93P
// module chunks = 0